import { useNavigate } from 'react-router-dom'
import dayjs from '../../libs/dayjs'
import { cnpjCpfMask, parseDate } from '../../utils/masks'

import { TableSentRecurrences } from './styles'
interface Props {
    sentRecurrences: never[]
}
const CreatedByYou = ({ sentRecurrences }: Props) => {
    const navigate = useNavigate()
    function renderRowsSentRecurrences() {
        return sentRecurrences.map((recurrence: any) => {
            return (
                <tr
                    onClick={() => navigate(`/recorrencia/${recurrence.id}`)}
                    key={recurrence.id}
                >
                    <td>
                        {dayjs(recurrence.createdAt).format(
                            'DD/MM/YYYY HH:mm:ss'
                        )}
                    </td>
                    <td>{recurrence.nomeTitular}</td>
                    <td>{cnpjCpfMask(recurrence.numeroDocumentoTitular)}</td>
                    <td>{parseDate(recurrence.data_liquidacao_atual, true)}</td>
                    <td>
                        {Number(recurrence.valor).toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                        })}
                    </td>
                    <td>{recurrence.situacao}</td>
                </tr>
            )
        })
    }
    return (
        <TableSentRecurrences>
            <thead>
                <tr>
                    <th>Data de criação</th>
                    <th>Recebedor</th>
                    <th>
                        CPF/CNPJ <br />
                        (Quem vai receber)
                    </th>
                    <th>Próxima liquidação</th>
                    <th>Valor</th>
                    <th>Status</th>
                </tr>
            </thead>

            <tbody>{renderRowsSentRecurrences()}</tbody>
        </TableSentRecurrences>
    )
}

export default CreatedByYou
